module.exports = __webpack_public_path__ + "img/printer.14c86172.svg";